import { useCallback, useMemo, useState } from "react";
import { matchesDateRange } from "../mock/operationsJournalMock";
import { matchesExtraFilters } from "../constants/extraFilters";

export const EMPTY_JOURNAL_FILTERS = {
  searchQuery: "",
  dateFrom: null,
  dateTo: null,
  organization: "",
  account: "",
  dataType: "",
  source: "",
  extraFilters: {},
};

/**
 * Фильтры журнала операций (поиск, период, селекты, «Добавить фильтр»).
 * getComment — откуда брать комментарий для поиска (в слое корректировок он свой);
 * ignoreTypeAndSource — «Тип данных» и «Источник» в слое не показываются и не применяются.
 */
export const filterJournalRows = (
  rows,
  filters,
  { getComment = (row) => row.comment, ignoreTypeAndSource = false } = {}
) => {
  const query = filters.searchQuery.trim().toLowerCase();
  return rows.filter((row) => {
    if (query) {
      const comment = getComment(row) || "";
      if (
        !row.document.toLowerCase().includes(query) &&
        !comment.toLowerCase().includes(query)
      ) {
        return false;
      }
    }
    if (!matchesDateRange(row.date, filters.dateFrom, filters.dateTo)) return false;
    if (filters.organization && row.organization !== filters.organization) return false;
    if (!ignoreTypeAndSource) {
      if (filters.dataType && row.dataType !== filters.dataType) return false;
      if (filters.source && row.source !== filters.source) return false;
    }
    return matchesExtraFilters(row, filters.extraFilters);
  });
};

function useJournalFilters(initialSearch = "") {
  const [filters, setFilters] = useState(() => ({
    ...EMPTY_JOURNAL_FILTERS,
    searchQuery: initialSearch,
  }));

  const updateFilters = useCallback(
    (patch) => setFilters((prev) => ({ ...prev, ...patch })),
    []
  );
  const resetFilters = useCallback(() => setFilters(EMPTY_JOURNAL_FILTERS), []);

  const hasActiveFilters = useMemo(
    () =>
      Boolean(
        filters.searchQuery ||
          filters.dateFrom ||
          filters.dateTo ||
          filters.organization ||
          filters.account ||
          filters.dataType ||
          filters.source
      ) || Object.keys(filters.extraFilters).length > 0,
    [filters]
  );

  return { filters, updateFilters, resetFilters, hasActiveFilters };
}

export default useJournalFilters;
